import { render, staticRenderFns } from "./TenantCreate.vue?vue&type=template&id=2663b88a"
import script from "./TenantCreate.vue?vue&type=script&lang=ts"
export * from "./TenantCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports